export const BetType = {
  Single: 'Single',
  Combo: 'Combo',
  System: 'System'
} as const

export type BetType = (typeof BetType)[keyof typeof BetType]
